import {colorMap} from "./colors";
import React from "react";

export default function ImdLegend() {
    	const renderEntry = (c) => {
		return (
			<div style={{
				display: "flex",
				gap: 8,
				paddingLeft: 22,
				paddingRight: 8,
				marginRight: 16,
				lineHeight: 1.3,
			}}>
				<span style={{
					flexShrink: 0,
					marginTop: 2,
					background: c[1],
					width: 16,
					height: 16,
				}}>
				</span>
				<span>{c[0]}</span>

				{c[0] === 1 && <span>Most deprived</span>}
				{c[0] === 10 && <span>Least deprived</span>}
			</div>
		)
	}

 	return (
		<div style={{
			marginBottom: 12,
		}}>
			<span style={{fontWeight: 'bold', paddingLeft: 22}}>IMD Decile</span>
			{colorMap.map(c => renderEntry(c))}
		</div>
	)
}